import cn from "classnames"

import style from "modules/PsyCommon/components/SessionCountLabel/style.module.scss"
import { ExperienceCategory } from "modules/PsyCatalog/common/ExperienceCategory"
import { getSessionCountEmoji } from "modules/PsyCatalog/common/getSessionCountEmoji"
import { getSessionCountText } from "modules/PsyCatalog/common/getSessionCountText"
import { Img } from "ui-kit/components-branded/index"

export function SessionCountLabel(props: { category: ExperienceCategory; className?: string }) {
    return (
        <div className={cn(style.wrapper, props.className)}>
            <Img className="labels__emoji" src={getSessionCountEmoji(props.category)} />
            <div>{getSessionCountText(props.category)}</div>
        </div>
    )
}
